import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import { hidePage } from '../../reducers/pageReducer';
import { uploadStart, uploadFinish } from '../../reducers/uploadReducer';
import * as modal from '../../reducers/modalReducer';
import { signIn, postProcessSignIn } from '../../actions/login';
import LoginFormContainer from '../LoginForm/LoginFormContainer';
import {
  isForgotPasswordByEmailEnabled,
  isPaymentKiosk as isPaymentKioskSelector
} from '../../selectors/configSelectors';
import { getPaymentKioskLoginMode } from '../../services/paymentKiosk';
import { LOGIN_MODE } from '../../const/paymentKiosk';
import { isProductInCartAndCustomerTypeMismatch } from '../../helpers/customer_type_helper';
import SmallModal from '../SmallModal/small_modal_container';
import CustomerTypeMismatchModelContent from '../CustomerTypeMismatchModelContent/customer_type_mismatch_model_content_container';

import './style.css';
import { getHoldProductCustomerTypes } from '../../selectors/hold_product_selectors';
import {
  isTaxByPackageCustomerType,
  isProductsByCustomerTypeEnabled,
} from '../../selectors/configSelectors';
import { resetHoldProduct } from '../../reducers/holdProductReducer';
import { STYLES } from '../Modal/model_styles';

class LoginFormModal extends Component {
  state = {
    isCustomerTypeMismatch: false,
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextState !== this.state;
  }
  isClosed = false;

  onCloseRequest = () => {
    if (this.isClosed) return;

    this.isClosed = true;

    this.props.hideModal();
  }

  getCustomerTypeFromResponse(signInResponse) {
    return signInResponse && signInResponse.data && signInResponse.data.customerType;
  }

  setCustomerMismatch(signInResponse) {
    this.setState({
      isCustomerTypeMismatch: true,
      signInResponse,
    });
  }

  postProcessSignIn(signInResponse) {
    this.props.postProcessSignIn(signInResponse.data);

    if (this.props.hasOwnProperty('handleClose')) {
      setTimeout(() => {
        this.props.handleClose();
      }, 1500);
    }
  }

  login(values) {
    const {
      holdProductCustomerTypes,
      isTaxByPackageCustomerType,
      isProductsByCustomerTypeEnabled,
    } = this.props;

    this.isClosed = true;

    this.props.uploadStart();

    signIn({
      email: values.email,
      password: values.password,
    })
      .then((signInResponse) => {
        const customerTypeFromResponse = this.getCustomerTypeFromResponse(signInResponse);
        const mismatch = isProductsByCustomerTypeEnabled && isProductInCartAndCustomerTypeMismatch(
          customerTypeFromResponse,
          holdProductCustomerTypes,
          isTaxByPackageCustomerType,
        );

        if (mismatch) {
          this.setCustomerMismatch(signInResponse);
        } else {
          this.postProcessSignIn(signInResponse);
        }
      })
      .catch((err) => {
        this.props.loginInfoForm({ isSuccess: false, handleResetPassword: this.handleResetPassword });
      })
      .finally(() => {
        this.props.uploadFinish();
      });
  }

  handleSubmit = (values) => {
    this.login(values);
  }

  handleResetPassword = () => {
    this.props.hidePage();
    this.props.hideModal();

    if (this.props.isForgotPasswordByEmailEnabled) {
      this.props.openResetPassword();
    } else {
      this.props.openReachOutUsResetPassword();
    }
  }

  handleSignup = (initialValues) => {
    this.isClosed = true;
    this.props.openSignUpForm(initialValues);
  }

  render() {
    const {
      isCustomerTypeMismatch,
      signInResponse,
    } = this.state;

    const {
      hideModal,
      resetOnHoldProduct,
      isPaymentKiosk,
    } = this.props;

    const paymentKioskloginMode = getPaymentKioskLoginMode();
    const isPaymentKioskWithLoginRedirect = isPaymentKiosk && paymentKioskloginMode === LOGIN_MODE.WITH_REDIRECT;
    const showCloseIcon = isPaymentKioskWithLoginRedirect ? false : true;
    const closeOnOverlayClick = isPaymentKioskWithLoginRedirect ? false : true;

    return (
      <React.Fragment>
        <Modal
          style={{ display: !isCustomerTypeMismatch ? '' : 'none' }}
          paddingTop={STYLES.paddingTopStyle}
          overlayTop={0}
          closeOnOverlayClick={closeOnOverlayClick}
          closeOnOutsideClick={false}
          isOpened={true}
          onClose={this.onCloseRequest}
        >
        <LoginFormContainer
          onCloseRequest={this.onCloseRequest}
          onSignUp={this.handleSignup}
          onSubmit={this.handleSubmit}
          showCloseIcon={showCloseIcon}
        />
        </Modal>

        {isCustomerTypeMismatch && (
          <SmallModal
            content={(
              <CustomerTypeMismatchModelContent
                onOk={() => {
                  resetOnHoldProduct();
                  this.postProcessSignIn(signInResponse);
                }}
                onCancel={() => {
                  hideModal();
                }}
                currentCustomerType={this.getCustomerTypeFromResponse(signInResponse)}
              />
            )}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    signup: state.signup,
    holdProduct: state.holdProduct,
    isPaymentKiosk: isPaymentKioskSelector(state),
    holdProductCustomerTypes: getHoldProductCustomerTypes(state),
    isTaxByPackageCustomerType: isTaxByPackageCustomerType(state),
    isProductsByCustomerTypeEnabled: isProductsByCustomerTypeEnabled(state),
    isForgotPasswordByEmailEnabled: isForgotPasswordByEmailEnabled(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideModal: () => dispatch(modal.hideModal()),
    resetOnHoldProduct: () => dispatch(resetHoldProduct()),
    openSignUpForm: (signUpFormValues) => dispatch(modal.openModal({
      modalType: 'SIGNUP_FORM',
      modalProps: {signUpFormValues}
    })),
    loginInfoForm: (props) => dispatch(modal.openModal({
      modalType: 'LOGIN_INFO_FORM',
      modalProps: props
    })),
    hidePage: () => dispatch(hidePage()),
    openSignUpConfirm: (props) => dispatch(modal.openModal({
      modalType: 'SIGNUP_CONFIRM_FORM',
      modalProps: {}
    })),
    openPasswordForm: () => dispatch(modal.openModal({
      modalType: 'PASSWORD_FORM',
      modalProps: {}
    })),
    openResetPassword: () => dispatch(modal.openModal({
      modalType: 'RESET_PASSWORD_FORM',
      modalProps: {}
    })),
    openReachOutUsResetPassword: () => dispatch(modal.openModal({
      modalType: 'REACH_OUT_US_RESET_PASSWORD',
      modalProps: {}
    })),
    uploadStart: () => dispatch(uploadStart()),
    uploadFinish: () => dispatch(uploadFinish()),
    postProcessSignIn: (signInData) => dispatch(postProcessSignIn(signInData))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginFormModal);



// WEBPACK FOOTER //
// ./src/components/LoginFormModal/LoginFormModal.jsx